import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { DropDownComponent } from "../../../Components/DropDownComponent";
import { TextComponent } from "../../../Components/TextComponent";
import { WidgetAnalyse } from "../Widgets/WidgetAnalyse";
import { app } from "../../../Frame/App";
import { ListView } from "../../../Components/ListView/ListView";
import { IListItem } from "../../../Model/IListItem";
import { INameValue } from "../../../Model/INameValue";
import { DonutChart } from "../Charts/DonutChart";
import { ChartRadioButton } from "../Components/ChartRadioButton";
import { ChartTypes } from "../Charts/ChartTypes";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { ListItem } from "../../../Model/ListItem";
import { RadioButtonComponent, RadioButtonOption } from "../../../Components/RadioButtonComponent";
import { Popup } from "../../../Areas/Leitplanke/Project/Popup";

export type PopupAnalyseComponentProps = {
    widget: WidgetAnalyse;
}

export class PopupAnalyseComponent extends JSXComponent {
    props: PopupAnalyseComponentProps;
    templates: ListView;
    title: LanguageStringComponent;
    dropdown: DropDownComponent;

    radioTypeDonut: ChartRadioButton;
    radioTypeBar: ChartRadioButton;
    radioTypeWaterfall: ChartRadioButton;

    private selectedSplitBy: number;

    constructor(props: PopupAnalyseComponentProps) {
        super(props);
    }

    onSave = (): boolean => {
        this.props.widget.props.templateIds = this.templates.getSelectedIds();

        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;

        if (this.radioTypeBar.props.checked) {
            this.props.widget.props.chartType = ChartTypes.Bar;
        }
        else if (this.radioTypeWaterfall.props.checked) {
            this.props.widget.props.chartType = ChartTypes.Waterfall;
        }
        else {
            this.props.widget.props.chartType = ChartTypes.Donut;
        }
        this.props.widget.props.showWithTable = this.dropdown.getValue() == "1";
        this.props.widget.recreate();
        return true;
    }

    onRadioTypeClicked = (control: ChartRadioButton): void => {
        if (!control.props.checked) {
            this.radioTypeDonut.setCheck(control.props.type == ChartTypes.Donut);
            this.radioTypeBar.setCheck(control.props.type == ChartTypes.Bar);
            this.radioTypeWaterfall.setCheck(control.props.type == ChartTypes.Waterfall);
        }
    }

    renderChartTypes(): HTMLElement[] {
        this.radioTypeDonut = new ChartRadioButton({
            type: ChartTypes.Donut,
            checked: this.props.widget.props.chartType == ChartTypes.Donut,
            onClick: this.onRadioTypeClicked
        });

        this.radioTypeBar = new ChartRadioButton({
            type: ChartTypes.Bar,
            checked: this.props.widget.props.chartType == ChartTypes.Bar,
            onClick: this.onRadioTypeClicked
        });

        this.radioTypeWaterfall = new ChartRadioButton({
            type: ChartTypes.Waterfall,
            checked: this.props.widget.props.chartType == ChartTypes.Waterfall,
            onClick: this.onRadioTypeClicked
        });

        return [this.radioTypeDonut.render(), this.radioTypeBar.render(), this.radioTypeWaterfall.render()];
    }

    renderTemplates(): HTMLElement {
        let div: HTMLElement = <div></div>;
        $.get(app.resolveUrl("~/api/measure/getTemplates"), (items: ListItem[]) => {
            this.templates = new ListView({
                name: Resources['WidgetClient'].templates,
                displayProperty: "name",
                idProperty: "id",
                checkedProperty: "checked",
                model: items,
                allowSelect: true,
                selectedIds: this.props.widget.props.templateIds
            });
            div.parentElement.insertBefore(this.templates.render(), div);
            div.parentElement.removeChild(div);
        })
        return div;
    }

    renderDropdown(): HTMLElement {
        this.dropdown = new DropDownComponent({
            id: app.createGuid(),
            name: Resources['WidgetClient'].showTable,
            displayProperty: "name",
            valueProperty: "value",
            addEmptyItem: false,
            items: [
                { name: Resources['WidgetClient'].showTableNo, value: "0" },
                { name: Resources['WidgetClient'].showTableYes, value: "1" },
            ]
        });
        return this.dropdown.render();
    }

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        });
        return this.title.render();
    }

    element: HTMLElement;
    getElement = () => {
        if (this.props.widget.props.splitBy == "ampel") {
            this.selectedSplitBy = 0;
        } else if (this.props.widget.props.splitBy == "status") {
            this.selectedSplitBy = 1;
        } else {
            this.selectedSplitBy = 0;
        }


        return <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].widgetAnalyse} cssClass="popup-analyse-component">
            <div className="mb-3">
                {this.renderTemplates()}
            </div>

            <RadioButtonComponent model={this}
                field="selectedSplitBy"
                options={[
                    { description: Resources['WidgetClient'].analyseSplitByAmpel, value: 0 },
                    { description: Resources['WidgetClient'].analyseSplitByStatus, value: 1 }
                ]}
                inline={true}
                name={Resources['WidgetClient'].analyseSplitBy}
                createFormGroup={true}
                changeEvent={(event: Event) => {
                    if (this.selectedSplitBy == 0) {
                        this.props.widget.props.splitBy = "ampel";
                    } else if (this.selectedSplitBy == 1) {
                        this.props.widget.props.splitBy = "status";
                    }
                }}
            />

            {this.renderTitle()}
            {this.renderDropdown()}
            <div className="form-group">
                <label className="form-label">{Resources['WidgetClient'].diagramType}</label>
                <div className="radio-button-row">
                    {...this.renderChartTypes()}
                </div>
            </div>
        </DynPopup>;
    }

    render(): HTMLElement {
        this.element = this.getElement();

        this.dropdown.setValue(this.props.widget.props.showWithTable ? "1" : "0");
        return this.element;
    }
}
